<template>
  <div class="form-view form-view__english">
    <div class="form-view-heading-wrapper">
      <h1 class="form-view-heading">HM event apply form</h1>
      <router-link to="/" class="el-link el-link--primary form-view-link">
        Chinese
      </router-link>
    </div>

    <el-row :gutter="10">
      <el-col
        :xs="{ span: 24, offset: 0 }"
        :sm="{ span: 18, offset: 3 }"
        :md="{ span: 16, offset: 4 }"
        :lg="{ span: 12, offset: 6 }"
        :xl="{ span: 8, offset: 8 }"
      >
        <div class="wrapper">
          <Form/>
        </div>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import Form from '@/components/FormEn.vue'

export default {
  name: 'english',
  components: {
    Form
  }
}
</script>

<style lang="sass" scoped>
.form-view-heading-wrapper
  text-align: center

  .form-view-heading
    display: inline-block

  .form-view-link
    margin-left: 20px

.wrapper
  background-color: rgba(0, 0, 0, 0.45)
  padding: 20px
</style>